import api from '../../redux/api';
import { SELLER_V1_BASE } from './constants';

const RewardsBaseUrl = `${SELLER_V1_BASE}/rewards`;

export const sellerRewardsService = {
  /**
   * List rewards (options) for current seller
   * GET /api/v1/seller/rewards
   */
  getRewards: async (params = {}) => {
    const response = await api.get(RewardsBaseUrl, { params });
    return response.data;
  },

  /**
   * Search rewards by name/description
   * GET /api/v1/seller/rewards/search
   */
  searchRewards: async (params = {}) => {
    const { page, limit, search, status, type, ...rest } = params;
    const q = {
      ...(page != null && { page }),
      ...(limit != null && { limit }),
      ...(search != null && search !== '' && { search }),
      ...(status != null && status !== '' && status !== 'all' && { status }),
      ...(type != null && type !== '' && type !== 'all' && { type }),
      ...rest,
    };
    const response = await api.get(`${RewardsBaseUrl}/search`, { params: q });
    return response.data;
  },

  /**
   * Get reward stats for current seller
   * GET /api/v1/seller/rewards/stats
   */
  getRewardStats: async (params = {}) => {
    const response = await api.get(`${RewardsBaseUrl}/stats`, { params });
    return response.data;
  },

  /**
   * Get reward details
   * GET /api/v1/seller/rewards/:rewardId
   */
  getReward: async (rewardId) => {
    const response = await api.get(`${RewardsBaseUrl}/${rewardId}`);
    return response.data;
  },

  /**
   * Create new reward
   * POST /api/v1/seller/rewards
   */
  createReward: async (rewardData) => {
    const response = await api.post(RewardsBaseUrl, rewardData);
    return response.data;
  },

  /**
   * Update reward
   * PUT /api/v1/seller/rewards/:rewardId
   */
  updateReward: async (rewardId, rewardData) => {
    const response = await api.put(`${RewardsBaseUrl}/${rewardId}`, rewardData);
    return response.data;
  },

  /**
   * Delete reward
   * DELETE /api/v1/seller/rewards/:rewardId
   */
  deleteReward: async (rewardId) => {
    const response = await api.delete(`${RewardsBaseUrl}/${rewardId}`);
    return response.data;
  },

  /**
   * Toggle/Update reward status
   * PATCH /api/v1/seller/rewards/:rewardId/toggle-status
   */
  updateRewardStatus: async (rewardId) => {
    const response = await api.patch(`${RewardsBaseUrl}/${rewardId}/toggle-status`,{});
    return response.data;
  },

  /**
   * Create a new experience location
   * POST /api/v1/seller/rewards/experience/location
   */
  createExperienceLocation: async (locationData) => {
    const response = await api.post(`${RewardsBaseUrl}/experience/location`, locationData);
    return response.data;
  },

  /**
   * Get experience locations
   * GET /api/v1/seller/rewards/experience/location
   */
  getExperienceLocations: async () => {
    const response = await api.get(`${RewardsBaseUrl}/experience/location`);
    return response.data;
  },

  /**
   * Get experience categories
   * GET /api/v1/seller/rewards/experience/categories
   */
  getExperienceCategories: async () => {
    const response = await api.get(`${RewardsBaseUrl}/experience/categories`);
    return response.data;
  },

  /**
   * Get governorates for experiences
   * GET /api/v1/seller/rewards/experience/governorates
   */
  getExperienceGovernorates: async () => {
    const response = await api.get(`${RewardsBaseUrl}/experience/governorates`);
    return response.data;
  },

  /**
   * List free products for reward configuration
   * GET /api/v1/seller/rewards/free-products
   */
  getFreeProducts: async () => {
    const response = await api.get(`${RewardsBaseUrl}/free-products`);
    return response.data;
  },

  /**
   * Add product to free products list
   * POST /api/v1/seller/rewards/free-products/:productId
   */
  addFreeProduct: async (productId) => {
    const response = await api.post(`${RewardsBaseUrl}/free-products/${productId}`);
    return response.data;
  },
};

export default sellerRewardsService;
